// axiosInstance.js

import axios from 'axios';
import store from '@/store/vuex'; // ✨ Vuex 스토어 임포트 추가

export const baseWsURL = import.meta.env.VITE_WS_BASE_URL; // ✅ WebSocket 환경변수 추가

const axiosInstance = axios.create({

    baseURL: import.meta.env.VITE_API_BASE_URL,
    withCredentials: true,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    },

    //baseURL: 'http://localhost:8080', // 개발 환경에서 사용한 주소
    //baseURL: 'http://localhost:8888', // 개발 환경에서 사용한 주소
    //baseURL: 'http://192.168.123.154:8888', // 개발 환경에서 사용한 주소
    //baseURL: 'http://13.209.138.27:8888', // 테스트 서버 도메인
    //baseURL: 'https://symon.co.kr', // 실서버 도메인
    // 기타 설정...
});

// ✅ 선별적 브라우저 캐시 방지: 실시간 정보가 필요한 API만 캐시 방지 적용
// 캐시하면 안 되는 API 패턴 목록 (세션, 실시간 데이터, 상태 조회 등)
const NO_CACHE_PATTERNS = [
    // 인증 & 세션
    // ℹ️ /sessionCheck는 router.js에서 30초 메모리 캐시로 관리됨.
    // 실제 서버 요청이 발생할 때만 이 패턴이 동작함 (정상 의도)
    '/sessionCheck', // 세션 정보는 항상 최신 정보 필요
    '/user/profile', // 사용자 프로필 변경 즉시 반영
    '/user/settings', // 사용자 설정 변경 즉시 반영

    // 실시간 대시보드
    '/mainDashboardData', // 대시보드 실시간 통계

    // 알람 & 이벤트
    '/selectAlertEventData', // 알람 이벤트 실시간 정보
    '/sseEventList', // SSE 이벤트 목록
    '/alert/count', // 알람 카운트 (실시간 업데이트 필요)

    // 카메라 & 스트리밍
    '/selectCameraStreaming', // 카메라 스트리밍 상태
    '/camera/status', // 카메라 상태 조회
    '/camera/current', // 카메라 현재 상태

    // WebSocket & MQTT
    '/ws/token', // WebSocket 인증 토큰
    '/mqtt/auth' // MQTT 인증
];

// axiosInstance.interceptors.request.use(
//     (config) => {
//         // GET 요청이고, 캐시 방지가 필요한 API인 경우에만 적용
//         if (config.method === 'get') {
//             const shouldPreventCache = NO_CACHE_PATTERNS.some(pattern =>
//                 config.url && config.url.includes(pattern)
//             );
//
//             // 명시적으로 noCache 옵션이 설정된 경우에도 적용
//             const explicitNoCache = config.noCache === true;
//
//             // if (shouldPreventCache || explicitNoCache) {
//                 config.params = config.params || {};
//                 if (!config.params._t) {
//                     config.params._t = Date.now();
//                 }
//                 config.headers = config.headers || {};
//                 if (!config.headers['Cache-Control']) {
//                     config.headers['Cache-Control'] = 'no-cache';
//                     config.headers['Pragma'] = 'no-cache';
//                 }
//             // }
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );

axiosInstance.interceptors.request.use(
    (config) => {
        if (config.method === 'get') {
            config.params = config.params || {};
            if (!config.params._t) {
                config.params._t = Date.now();
            }
            config.headers = config.headers || {};
            if (!config.headers['Cache-Control']) {
                config.headers['Cache-Control'] = 'no-cache';
                config.headers['Pragma'] = 'no-cache';
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let isSessionExpiredHandling = false; // ✨ 동시다발 401 발생 시 alert/redirect 중복 실행 방지

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        const contentType = error?.response?.headers?.['content-type'] || '';

        // 서버에서 HTML 형태의 에러 페이지를 내려줄 때의 방어 로직
        if (typeof error?.response?.data === 'string' && contentType.includes('text/html')) {
            console.error('API 요청에서 HTML 응답이 반환되었습니다. fallback 또는 요청 경로를 확인하세요.', {
                url: error?.config?.url,
                status: error?.response?.status
            });
        }

        // ✨ [수정됨] 401 Unauthorized (세션 만료) 감지 및 로그인 페이지 강제 리다이렉트
        if (error?.response?.status === 401) {
            const url = error.config?.url ?? '';
            // 로그인이나 세션체크 자체의 401은 무한루프 방지를 위해 제외
            const isAuthCall = url.includes('/login-proc') || url.includes('/sessionCheck');

            if (!isAuthCall && !isSessionExpiredHandling && window.location.pathname !== '/auth/login') {
                isSessionExpiredHandling = true;

                // 사용자가 가려던 마지막 경로 저장
                sessionStorage.setItem('preLoginRoute', window.location.pathname + window.location.search);

                alert('세션이 만료되었습니다. 안전을 위해 다시 로그인해 주세요.');

                // 스토어 초기화 및 로그인 페이지로 이동
                store.dispatch('logout');
                window.location.href = '/auth/login';
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
